import { render, staticRenderFns } from "./dialog-changestatus_user.vue?vue&type=template&id=5f8282ff&"
import script from "./dialog-changestatus_user.vue?vue&type=script&lang=js&"
export * from "./dialog-changestatus_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports